import { ArrowLeft, History, Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/shared/ui/button'

export function AiChatConversationControls({
  disabled,
  historyOpen,
  onNewConversation,
  onHistory,
  onBack,
}: {
  disabled: boolean
  historyOpen: boolean
  onNewConversation: () => void
  onHistory: () => void
  onBack: () => void
}) {
  const { t } = useTranslation('aiChat')

  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={historyOpen ? onBack : onHistory}
      >
        {historyOpen ? (
          <ArrowLeft className="size-4" aria-hidden="true" />
        ) : (
          <History className="size-4" aria-hidden="true" />
        )}
        {t(historyOpen ? 'backToConversation' : 'history')}
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={onNewConversation}
        title={t('newConversationHint')}
      >
        <Plus className="size-4" aria-hidden="true" />
        {t('newConversation')}
      </Button>
    </div>
  )
}
